<template>
  <div>
    <table v-show="results.length">
      <tr>
        <th>Date started</th>
        <th>Date finished</th>
        <th>Score</th>
        <th>Result</th>
      </tr>
      <tr  :key="result.id" v-for="result in results">
        <td>{{result.time_start ? $moment(result.time_start).format('MM/DD/YYYY') : ''}}</td>
        <td>{{result.time_end ? $moment(result.time_end).format('MM/DD/YYYY') : ''}}</td>
        <td>{{result.score}}</td>
        <td><a target="_blank" :href="'/quiz/' + result.vid + '/result/' + result.id + '?standalone=1'">View Result</a></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {results: Array},
}
</script>

